<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div [class.isPrinting]="printService.isPrinting">

  <div class="job-posts placements agreements margin-top-service-30px top-link">
    <div class="card my-profile-form skillassest-form">



    </div>
    <div class="card-body padding-top padding-left-0px padding-right-0px scansstyle">
      <div class="row">
        <div class="col-md-3 padding-right-0px colmd3">
          <div class="position-fixed-scans border-right2 padding-right-5px height-100pe">
            <div class="card height-100pe">

              <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
                <div class="row margin-top10px margin-left-20px  nav-link-hand">
                  <div class="col-md-10 padding-left-0px">
                    <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                      Follicular Scans
                    </label>
                  </div>





                  <div class="col-md-1">
                    <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
                  </div>
                  <!--<a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                  *ngIf="ShowIcon"><i class="fas fa-angle-double-left font-size-19px"></i></a>-->

                </div>




              </div>
              <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
                <!--<ngx-spinner bdColor="rgba(0,0,0,0)"
                             size="medium"
                             color="#000000"
                             type="ball-spin-clockwise">
                </ngx-spinner>-->
                <div class="row border-top margin-left-0px margin-right-0px">
                  <div class="col-md-5 col-sm-4 padding-right-0px my-profile-form margin-left-10px">
                    <div class="date-form margin-top-5px form-group margin-bottom-0px">
                      <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>



                  </div>
                  <div class="col-md-1 " (click)="DecrementDate()">
                    <a title="Previous" class="nav-link-hand">
                      <i class="fas fa-caret-left margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                  <div class="col-md-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                    <a title="Next" class="nav-link-hand">
                      <i class="fas fa-caret-right margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                </div>
                <div class="row margin-right-0px margin-left-0px">
                  <div class="col-md-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                    <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
                  </div>
                  <div class="col-md-2" hidden>
                    <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Edit">
                      <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                    </a>

                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Delete">
                      <span class="badge font-size-14">
                        <i class="far fa-trash-alt"></i>
                      </span>
                    </a>
                  </div>

                </div>
                <div>
                  <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps scroll padding-lrt " data-ps-id="dfsfsde">
                    <div *ngIf="isRequesting">

                      <div class="loader-text">
                        <div class="loader-text2">

                          <div class="lds-facebook">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                          <div class="margin-top-20px margin-left-5px">
                            <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                          </div>
                          <!--Loading Please Wait...-->
                        </div>
                      </div>


                    </div>
                    <div *ngIf="!isRequesting">
                      <div class="row border-bottom row-for-scans2 margin-left16px nav-link-hand" (click)="Selectedpatient(l)" *ngFor="let l of pdata">
                        <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient(l)">
                          <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.FollicularGrowthOwnerPatientImageFile" onError="this.src='dummy.jpg';">



                        </div>
                        <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.OwnerName}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerAgeYears}},{{l.OwnerFormattedCode}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-4">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerTelephone1}}</label>
                            </div>
                          </div>

                        </div>
                        <div class="col-md-3 padding-left-0px margin-top-5px">
                          <div class="text-align-center"><label class="font-size-12px">#{{l.CycleNo}}</label></div>

                          <div class="text-align-center">

                            <a data-toggle="tooltip" data-placement="bottom" title="Completed" *ngIf="l.ActivityStatus=='Completed'">

                              <i class="fas fa-check-circle color-icon-completed font-size-16px">
                              </i>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="Initiated" *ngIf="l.ActivityStatus=='Initiated'">

                              <i class="fas fa-check-circle color-gray font-size-16px">
                              </i>
                            </a>
                            <!--<i class="fas fa-check-circle color-icon-completed "></i>-->

                          </div>
                          <!--<div class="text-align-center"><label class="font-size-12px">{{l.LastUpdatedTime | date: 'hh:mm a'}}</label></div>-->
                        </div>
                      </div>
                    </div>
                    <!--<div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                      <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                        <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                      </div>
                      <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="margin-bottom-0px">Ramya santhosh</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>-->
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div class="col-md-6 padding-left-17px padding-right-8px CycleTest" *ngIf="ScanDetails">

          <div class="row" *ngIf="SelectedpatientDetails">
            <div class="col-md-12 padding-left-0px">
              <div class="card">
                <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px">
                  <div class="row">
                    <div class="col-md-1 ">
                      <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.FollicularGrowthOwnerPatientImageFile" onError="this.src='dummy.jpg';">
                    </div>
                    <div class="col-md-4 margin-left-18">
                      <div class="row row-height-17px margin-left-0px">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.OwnerName}} </label>
                        </div>
                      </div>
                      <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(for : {{SelectedpatientDetails.FollicularGrowthOwnerName}}) </label>
                        </div>
                      </div>
                      <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>-->
                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.FollicularGrowthOwnerAgeYears}},{{SelectedpatientDetails.FollicularGrowthOwnerFormattedCode}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.FollicularGrowthOwnerTelephone1}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-3">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
                        </div>
                        <div class="col-md-9 padding-left-6px">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
                        </div>

                      </div>

                    </div>
                    <div class="col-md-6  padding-right-0px">
                      <!--<div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="FollicularData2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
                        </div>
                      </div>-->
                      <div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="FollicularData2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularData2.ActivityStatus}}</label>
                        </div>
                      </div>
                      <div class="row font-size-12px" *ngIf="FollicularScanEndInfo">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Scan Date </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularScanEndInfo.ScanDate | date:'MMM-dd-yyyy'}}</label>
                        </div>
                      </div>
                      <!--<div class="row">
                        <div class="col-md-1 margin-left-auto padding-left-7px">
                          <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
                          </div>
                        <div class="col-md-1 padding-left-7px">
                          <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
                        </div>

                         <div class="col-md-1 padding-left-7px">

                          <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
                        </div>

                      </div>-->
                      <div class="row margin-right-0px">
                        <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
                        </div>
                        <div class="Dsa2" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
                        </div>
                        <div class="Dsa3" *ngIf="DSADetails">

                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-right-0px padding-top-0px padding-bottom-0px">

                  <div class="card">
                    <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                      <div class="row nav-link-hand margin-right-0px" id="edit-link">
                        <div class="col-md-6 padding-right-0px">
                          <label class="margin-bottom-0px font-size-16px font-weight-normal">
                            Follicular Scans
                          </label>
                        </div>
                        <div class="col-md-5  padding-right-0px display-edit">
                          <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                          <div class="row float-right" *ngIf="FollicularData2">
                            <div class="col-md-10 margin-top-3px padding-left-0px padding-right-0px text-align-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup || FollicularData2.ActivityStatus !=='Completed'">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Ready For Transfer" *ngIf="SelectedpatientDetails.TCModelName=='Fet' && ActorCodeDetails.CycleType!=='IUI'">Is Ready For Transfer</a>
                              <!--<a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Ready For Transfer" *ngIf="SelectedpatientDetails.TCModelName=='Fet' && ActorCodeDetails.CycleType=='IUI'">Is Ready For Transfer</a>-->
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Ready For PickUp" *ngIf="SelectedpatientDetails.TCModelName!=='Fet' && ActorCodeDetails.CycleType=='IVF'"> Is Ready For PickUp</a>
                              <!--<a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="Assessment()" title="Assessment Completed" *ngIf="ActorCodeDetails.CycleType=='IUI'"> Assessment Completed</a>-->
                            </div>

                            <!--<div class="col-md-1">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printfollicular()">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>-->
                            <div class="col-md-1">
                              <div *ngIf="FollicularData2">
                                <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printfollicular2()">
                                  <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                                </a>
                              </div>
                              <!--<a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printfollicular2()" >
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>-->
                            </div>
                          </div>




                        </div>

                      </div>
                    </div>
                    <div class=" padding-lrt " data-ps-id="dfsfsde">
                      <div class="card-body">
                        <div *ngIf="FollicularScanEndInfo && FollicularData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                            <div class="accordion" id="accordionExample" *ngIf="FollicularData2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                          Endrometrium Thickness
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button (click)="SaveEndometriumdetails()" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup" [disabled]="Endometrium.errors?.required || addconcerns_text.errors?.required || sign1.errors?.required || sign2.errors?.required ">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                  </div>


                                </div>

                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Scan Date </label>
                                          </div>


                                          <div class="col-md-3">

                                            <div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp1" [(ngModel)]="ScanDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                              <!--<small class="form-text text-danger"
                                              *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>-->
                                              <a (click)="d1.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Endometrium Thickness </label>
                                          </div>


                                          <div class="col-md-3">

                                            <input type="text" class="form-control" placeholder="Endometrium Thickness"
                                                   id="FollicularScanEndInfo.EndometriumThickness"
                                                   [(ngModel)]="FollicularScanEndInfo.EndometriumThickness"
                                                   name="FollicularScanEndInfo.EndometriumThickness" #Endometrium="ngModel"
                                                   maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>

                                          </div>
                                          <div class="col-md-2">
                                            <CodeTypeValue CodeType="ENMU"
                                                           id="FollicularScanEndInfo.EndometriumThicknessUnits"
                                                           [(ngModel)]="FollicularScanEndInfo.EndometriumThicknessUnits" SelectedValue="FollicularScanEndInfo.EndometriumThicknessUnits"
                                                           name="FollicularScanEndInfo.EndometriumThicknessUnits">
                                            </CodeTypeValue>


                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Comments</label>
                                          </div>

                                          <div class="col-md-4 padding-right-0px">
                                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                                                      name="FollicularScanEndInfo.Comments"
                                                      [(ngModel)]="FollicularScanEndInfo.Comments" required minlength="1" maxlength="100"
                                                      #addconcerns_text="ngModel"></textarea>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Sign1</label>
                                          </div>

                                          <div class="col-md-4 padding-right-0px">
                                            <CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                                     id="FollicularScanEndInfo.Sign1Actor" SelectedValue="FollicularScanEndInfo.Sign1Actor"
                                                                     [(ngModel)]="FollicularScanEndInfo.Sign1Actor" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                                     name="FollicularScanEndInfo.Sign1Actor" required #sign1="ngModel">
                                            </CustomDataByRequestType>

                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Sign2</label>
                                          </div>

                                          <div class="col-md-4 padding-right-0px">
                                            <CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                                     id="FollicularScanEndInfo.Sign2Actor" SelectedValue=""
                                                                     [(ngModel)]="FollicularScanEndInfo.Sign2Actor" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                                     name="FollicularScanEndInfo.Sign2Actor" required #sign2="ngModel">
                                            </CustomDataByRequestType>

                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div *ngIf="FollicularScanEndInfo && FollicularData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                            <div class="accordion" id="accordionExample" *ngIf="FollicularData2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                          Endrometrium Thickness
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button (click)="SaveEndometriumdetails()" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup" [disabled]="Endometrium.errors?.required || addconcerns_text.errors?.required || sign1.errors?.required || sign2.errors?.required ">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                  </div>


                                </div>

                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Scan Date </label>
                                          </div>:


                                          <div class="col-md-5 margin-tg-auto">

                                            <!--<div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d1.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>-->
                                            <label class="margin-bottom-0px ">{{FollicularScanEndInfo.ScanDate | date:'MMM-dd-yyyy'}}</label>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto padding-left-0px">
                                            <label for="diaplayName" class="margin-bottom-0px white-space-nowrap">Endometrium Thickness </label>
                                          </div>:


                                          <div class="col-md-3 margin-tg-auto">

                                            <!--<input type="text" class="form-control" placeholder="Dose" id="FollicularPickupEndInfo.Dosage"
                                            [(ngModel)]="FollicularPickupEndInfo.Dosage" required
                                            name="FollicularPickupEndInfo.Dosage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                            maxlength="100">-->

                                            <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.EndometriumThickness}}{{FollicularScanEndInfo.EndometriumThicknessUnits}}</label>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Comments </label>
                                          </div>:


                                          <div class="col-md-4 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.Comments}}</label>
                                            <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode" required>
                                            </CustomDataByRequestType>-->
                                            <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                            <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                            maxlength="100" required>-->
                                            <!--<small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Sign1 </label>
                                          </div>:


                                          <div class="col-md-4 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.Sign1}}</label>
                                            <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode" required>
                                            </CustomDataByRequestType>-->
                                            <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                            <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                            maxlength="100" required>-->
                                            <!--<small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Sign2 </label>
                                          </div>:


                                          <div class="col-md-4 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.Sign2}}</label>
                                            <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode" required>
                                            </CustomDataByRequestType>-->
                                            <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                            <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                            maxlength="100" required>-->
                                            <!--<small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                        <!--<div *ngIf="FollicularScanEndInfo.EndometriumThickness">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                            <div class="accordion" id="accordionExample">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                          Endrometrium Thickness
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button (click)="SaveEndometriumdetails()" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                  </div>


                                </div>

                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Scan Date </label>
                                          </div>


                                          <div class="col-md-3">

                                            <div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp1" [(ngModel)]="ScanDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d1.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Endometrium Thickness </label>
                                          </div>


                                          <div class="col-md-3">

                                            <input type="text" class="form-control" placeholder="Endometrium Thickness"
                                                   id="FollicularScanEndInfo.EndometriumThickness"
                                                   [(ngModel)]="FollicularScanEndInfo.EndometriumThickness"
                                                   name="FollicularScanEndInfo.EndometriumThickness" #Endometrium="ngModel"
                                                   maxlength="100" required>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(special characters are not allowed)</small>

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Comments</label>
                                          </div>

                                          <div class="col-md-4 padding-right-0px">
                                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                                                      name="FollicularScanEndInfo.Comments"
                                                      [(ngModel)]="FollicularScanEndInfo.Comments" required minlength="1" maxlength="100"
                                                      #addconcerns_text="ngModel"></textarea>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                                          </div>
                                        </div>


                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>-->

                        <div *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.TCModelName=='Fet' && FollicularData2 && FollicularScanEndInfo">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitAdditional()" #f="ngForm" *ngIf="FollicularData2.ActivityStatus !=='Completed'">
                            <div class="accordion" id="accordionExample7">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="heading7">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapse7" aria-expanded="true" aria-controls="collapse7">
                                          Additional Details
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                  </div>


                                </div>

                                <div id="collapse7" class="collapse show" aria-labelledby="heading7" data-parent="#accordionExample7">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">


                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Blood Flow Zone</label>
                                          </div>

                                          <div class="col-md-3">
                                            <CodeTypeValue CodeType="BFLWZ"
                                                           id="FollicularScanEndInfo.BloodFlowZone"
                                                           [(ngModel)]="FollicularScanEndInfo.BloodFlowZone" SelectedValue="FollicularScanEndInfo.BloodFlowZone"
                                                           name="FollicularScanEndInfo.BloodFlowZone">
                                            </CodeTypeValue>

                                          </div>
                                        </div>


                                      </div>
                                    </div>


                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto">
                                            <label for="diaplayName" class="font-size-16px margin-bottom-0px font-weight-bold">Adjuvants:</label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Evion</label>
                                          </div>


                                          <div class="col-md-3">

                                            <CodeTypeValue CodeType="YESNO"
                                                           id="FollicularScanEndInfo.Evion"
                                                           [(ngModel)]="FollicularScanEndInfo.Evion" SelectedValue="FollicularScanEndInfo.Evion"
                                                           name="FollicularScanEndInfo.Evion">
                                            </CodeTypeValue>


                                          </div>

                                        </div>


                                      </div>
                                    </div>

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Intauterine GCSF</label>
                                          </div>


                                          <div class="col-md-3">

                                            <CodeTypeValue CodeType="YESNO"
                                                           id="FollicularScanEndInfo.GCSF"
                                                           [(ngModel)]="FollicularScanEndInfo.GCSF" SelectedValue="FollicularScanEndInfo.GCSF"
                                                           name="FollicularScanEndInfo.GCSF">
                                            </CodeTypeValue>

                                            <!--<input type="text" class="form-control" placeholder="Intauterine GCSF"
                                                   id="FollicularScanEndInfo.GCSF"
                                                   [(ngModel)]="FollicularScanEndInfo.GCSF"
                                                   name="FollicularScanEndInfo.GCSF" #GCSF="ngModel"
                                                   maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!GCSF.valid && (GCSF.dirty || GCSF.touched) && GCSF.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!GCSF.valid && GCSF.errors.pattern)">(only numbers are allowed)</small>-->

                                          </div>

                                        </div>


                                      </div>
                                    </div>

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">BAPC</label>
                                          </div>


                                          <div class="col-md-3">

                                            <CodeTypeValue CodeType="YESNO"
                                                           id="FollicularScanEndInfo.BAPC"
                                                           [(ngModel)]="FollicularScanEndInfo.BAPC" SelectedValue="FollicularScanEndInfo.BAPC"
                                                           name="FollicularScanEndInfo.BAPC">
                                            </CodeTypeValue>

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="table-component margin-bottom-0px padding-all-3px">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero">

                                          <thead class="">
                                            <tr>
                                              <th class=" td-width-107px padding-left-4"></th>
                                              <th class="padding-left-5px width-70px">UterineArtery Left</th>
                                              <th class="padding-left-5px width-70px">UterineArtery Right</th>


                                            </tr>
                                          </thead>
                                          <tbody class="table-body">
                                            <tr>
                                              <!--<td class="td-padding text-align-center">

                                                                              <input type="checkbox" [(ngModel)]="IsLeft" (change)="LeftOrRight('Left',isChecked? 'true' : 'false')" />


                                                                            </td>
                                                                            <td class="td-padding text-align-center">

                                                                              <input type="checkbox" [(ngModel)]="IsRight"
                                                                                     (change)="LeftOrRight('Right' ,isChecked? 'true' : 'false')" />


                                              </td>-->
                                              <td class="padding-all-0px">
                                                RI
                                              </td>

                                              <td class="td-padding ">

                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="FollicularScanEndInfo.RILeft"
                                                       [(ngModel)]="FollicularScanEndInfo.RILeft"
                                                       name="FollicularScanEndInfo.RILeft" #Count="ngModel"
                                                       maxlength="50">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                              </td>
                                              <td class="td-padding ">
                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="FollicularScanEndInfo.RIRight"
                                                       [(ngModel)]="FollicularScanEndInfo.RIRight"
                                                       name="FollicularScanEndInfo.RIRight" #Size="ngModel"
                                                       maxlength="50">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                              </td>





                                            </tr>
                                            <tr>
                                              <!--<td class="td-padding text-align-center">

                                                                              <input type="checkbox" [(ngModel)]="IsLeft" (change)="LeftOrRight('Left',isChecked? 'true' : 'false')" />


                                                                            </td>
                                                                            <td class="td-padding text-align-center">

                                                                              <input type="checkbox" [(ngModel)]="IsRight"
                                                                                     (change)="LeftOrRight('Right' ,isChecked? 'true' : 'false')" />


                                              </td>-->
                                              <td class="padding-all-0px">
                                                PI
                                              </td>

                                              <td class="td-padding ">

                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="FollicularScanEndInfo.PILeft"
                                                       [(ngModel)]="FollicularScanEndInfo.PILeft"
                                                       name="FollicularScanEndInfo.PILeft" #Count="ngModel"
                                                       maxlength="50">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                              </td>
                                              <td class="td-padding ">
                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="FollicularScanEndInfo.PIRight"
                                                       [(ngModel)]="FollicularScanEndInfo.PIRight"
                                                       name="FollicularScanEndInfo.PIRight" #Size="ngModel"
                                                       maxlength="50">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                              </td>





                                            </tr>


                                          </tbody>

                                        </table>

                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.TCModelName=='Fet' && FollicularData2 ">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitAdditional()" #f="ngForm" *ngIf="FollicularData2.ActivityStatus =='Completed'">
                            <div class="accordion" id="accordionExample7" *ngIf="FollicularData2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="heading7">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapse7" aria-expanded="true" aria-controls="collapse7">
                                          Additional Details
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup" [disabled]="GCSF.errors?.required || BAPC.errors?.required">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                  </div>


                                </div>

                                <div id="collapse7" class="collapse show" aria-labelledby="heading7" data-parent="#accordionExample7">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Blood Flow Zone </label>
                                          </div>:


                                          <div class="col-md-3 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.BloodFlowZone}}</label>
                                            <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode" required>
                                            </CustomDataByRequestType>-->
                                            <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                            <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                            maxlength="100" required>-->
                                            <!--<small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                          </div>

                                        </div>


                                      </div>
                                    </div>


                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Adjuvants </label>
                                          </div>:


                                          <div class="col-md-4 margin-tg-auto">
                                            <!--<label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.UterineArteryRight}}</label>-->
                                            <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode" required>
                                            </CustomDataByRequestType>-->
                                            <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                            <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                            maxlength="100" required>-->
                                            <!--<small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                          </div>



                                        </div>




                                      </div>
                                    </div>

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Evion </label>
                                          </div>:


                                          <div class="col-md-4 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.Evion}}</label>

                                          </div>

                                        </div>


                                      </div>
                                    </div>

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Intauterine GCSF </label>
                                          </div>:


                                          <div class="col-md-4 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.GCSF}}</label>
                                            <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode" required>
                                            </CustomDataByRequestType>-->
                                            <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                            <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                            maxlength="100" required>-->
                                            <!--<small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">BAPC </label>
                                          </div>:


                                          <div class="col-md-4 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.BAPC}}</label>
                                            <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode" required>
                                            </CustomDataByRequestType>-->
                                            <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                            <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                            maxlength="100" required>-->
                                            <!--<small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                          </div>

                                        </div>


                                      </div>
                                    </div>

                                    <div class="table-component margin-bottom-0px padding-all-3px">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero">

                                          <thead class="">
                                            <tr>
                                              <th class=" td-width-107px padding-left-4"></th>
                                              <th class="padding-left-5px width-70px">UterineArtery Left</th>
                                              <th class="padding-left-5px width-70px">UterineArtery Right</th>


                                            </tr>
                                          </thead>
                                          <tbody class="table-body">
                                            <tr>

                                              <td class="padding-all-0px">
                                                RI
                                              </td>

                                              <td class="td-padding ">
                                                <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.RILeft}}</label>
                                                <!--<input type="text" class="form-control"
                                                       min="1" max="10" id="FollicularScanEndInfo.RILeft"
                                                       [(ngModel)]="FollicularScanEndInfo.RILeft"
                                                       name="FollicularScanEndInfo.RILeft" #Count="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>-->

                                              </td>
                                              <td class="td-padding ">
                                                <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.RIRight}}</label>
                                                <!--<input type="text" class="form-control"
                                                       min="1" max="10" id="FollicularScanEndInfo.RIRight"
                                                       [(ngModel)]="FollicularScanEndInfo.RIRight"
                                                       name="FollicularScanEndInfo.RIRight" #Size="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>-->
                                              </td>





                                            </tr>
                                            <tr>

                                              <td class="padding-all-0px">
                                                PI
                                              </td>

                                              <td class="td-padding ">
                                                <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.PILeft}}</label>
                                                <!--<input type="text" class="form-control"
                                                       min="1" max="10" id="FollicularScanEndInfo.PILeft"
                                                       [(ngModel)]="FollicularScanEndInfo.PILeft"
                                                       name="FollicularScanEndInfo.PILeft" #Count="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>-->

                                              </td>
                                              <td class="td-padding ">
                                                <label class="margin-bottom-0px " *ngIf="FollicularScanEndInfo">{{FollicularScanEndInfo.PIRight}}</label>
                                                <!--<input type="text" class="form-control"
                                                       min="1" max="10" id="FollicularScanEndInfo.PIRight"
                                                       [(ngModel)]="FollicularScanEndInfo.PIRight"
                                                       name="FollicularScanEndInfo.PIRight" #Size="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>-->
                                              </td>





                                            </tr>


                                          </tbody>

                                        </table>

                                      </div>
                                    </div>




                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div class="accordion" id="accordionExample2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitOvary()" #f="ngForm">
                            <div class="card margin-bottom-5px">
                              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                                <div class="row">
                                  <div class="col-md-4">
                                    <h5 class="mb-0 height-24px">
                                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                        Follicles (Count/Size)
                                      </button>
                                    </h5>
                                  </div>
                                  <div class="col-md-8">
                                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                    <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup && isvisible">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                  </div>
                                  <!--<div class="col-md-6">
                                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                    <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                  </div>-->
                                </div>


                              </div>

                              <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                                <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                                  <div class="card margin-bottom-0px ">

                                    <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                      <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                        <div class="table-responsive">


                                          <table class="table table-striped margin-left-zero">

                                            <thead class="">
                                              <tr>
                                                <th class=" td-width-107px padding-left-4">Ov.Position</th>
                                                <th class="padding-left-5px width-80px">Count</th>
                                                <th class="padding-left-5px width-80px">Size</th>
                                                <th>Comments</th>

                                              </tr>
                                            </thead>
                                            <tbody class="table-body">

                                              <tr>
                                                <!--<td class="td-padding text-align-center">

                                                                                <input type="checkbox" [(ngModel)]="IsLeft" (change)="LeftOrRight('Left',isChecked? 'true' : 'false')" />


                                                                              </td>
                                                                              <td class="td-padding text-align-center">

                                                                                <input type="checkbox" [(ngModel)]="IsRight"
                                                                                       (change)="LeftOrRight('Right' ,isChecked? 'true' : 'false')" />


                                                </td>-->
                                                <td class="padding-all-0px">
                                                  <CodeTypeValue CodeType="OVPS"
                                                                 id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                                                 [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                                                 name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                                                  </CodeTypeValue>
                                                </td>

                                                <td class="td-padding ">

                                                  <input type="number" class="form-control padding-left-2px padding-right-2px"
                                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                                         maxlength="100">
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                                </td>
                                                <td class="td-padding ">
                                                  <input type="number" class="form-control padding-left-2px padding-right-2px"
                                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                                         maxlength="100">
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                                </td>

                                                <td class="td-padding ">
                                                  <input type="text" class="form-control"
                                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                                         maxlength="100">
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                                </td>



                                              </tr>

                                            </tbody>

                                          </table>

                                        </div>
                                      </div>

                                      <div class="row my-profile-form" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                          <div class="row">
                                            <div class="col-md-3 padding-right-0px text-align-right margin-top-auto">
                                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">AFC Count</label>
                                            </div>

                                            <div class="col-md-3">
                                              <!--<input type="number" class="form-control"
                                              min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount"
                                              [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount"
                                              name="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount" #AFCCount="ngModel"
                                              maxlength="100">-->
                                              <input type="text" class="form-control"
                                                     min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount"
                                                     [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount"
                                                     name="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount" pattern="^[\0-9,._\-?]*$" #AFCCount="ngModel"
                                                     maxlength="5">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!AFCCount.valid && (AFCCount.dirty || AFCCount.touched) && AFCCount.errors.required )">(Field cannot be left blank)</small>
                                              <small class="form-text text-danger"
                                                     *ngIf="(!AFCCount.valid && AFCCount.errors.pattern)">(only numbers are allowed)</small>

                                              <!--<input type="text" class="form-control" placeholder="Cycle No"
                                                     id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                                                     [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                                                     name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                                     maxlength="5" />
                                              <small class="form-text text-danger"
                                                     *ngIf="(!RecommendedPackage.valid && (RecommendedPackage.dirty || RecommendedPackage.touched) && RecommendedPackage.errors.required )">(Field cannot be left blank)</small>
                                              <small class="form-text text-danger"
                                                     *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>-->


                                            </div>
                                          </div>


                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>
                                <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                  <div class="card margin-bottom-0px background-lightpink">

                                    <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                      <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                        <div class="table-responsive">


                                          <table class="table table-striped margin-left-zero">

                                            <thead class="">
                                              <tr>
                                                <th class=" td-width-107px">Ov.Position</th>
                                                <th class="padding-left-5px width-70px">Count</th>
                                                <th class="padding-left-5px width-70px">Size</th>
                                                <th>Comments</th>

                                              </tr>
                                            </thead>
                                            <tbody class="table-body">

                                              <tr>

                                                <td>
                                                  <CodeTypeValue CodeType="OVPS"
                                                                 id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                                                 [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                                                 name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                                                  </CodeTypeValue>
                                                </td>

                                                <td class="td-padding ">

                                                  <input type="number" class="form-control"
                                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                                         maxlength="100">
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                                </td>
                                                <td class="td-padding ">
                                                  <input type="text" class="form-control"
                                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                                         maxlength="100">
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                                </td>

                                                <td class="td-padding ">
                                                  <input type="text" class="form-control"
                                                         min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                         name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                                         maxlength="100">
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                                </td>



                                              </tr>

                                            </tbody>

                                          </table>

                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>-->
                              </div>
                            </div>
                          </form>

                        </div>
                        <div class="row margin-left-0px">
                          <div class="col-md-6 border-right-1px">
                            <div class="card">
                              <div class="card-header wh-header padding-right-0px padding-bottom-0px padding-top-0px padding-left-10px left-ovaries-background">
                                <label class="font-weight-normal font-size-14 margin-bottom-0px">Left Ovary</label>
                              </div>
                              <div class="card-body padding-top-0px padding-bottom-0px">
                                <div class="row">
                                  <div class="col-md-12 padding-left-0px padding-right-0px">
                                    <div class="table-component">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero">

                                          <!--<thead class="">
                                            <tr>
                                              <th class="min-width-0px">Left</th>

                                              <th class="min-width-0px">Right</th>
                                              <th>Count</th>
                                              <th>Size</th>

                                            </tr>
                                          </thead>-->
                                          <tbody class="table-body">
                                            <ng-container *ngFor="let l of CurrentFollicularScanOvaryDetailController">
                                              <tr *ngIf="l.OvarPos == 'Left'|| l.OvarPos == 'LEFT'">
                                                <td class="td-padding ">

                                                  <!--<label *ngIf="l.OvarPos == 'Left' || 'LEFT' && l.OvarPos != 'Right' || 'RIGHT' ">{{l.Count}}</label>-->
                                                  <label class="margin-bottom-0px">{{l.Count}}</label>

                                                </td>
                                                <td class="td-padding ">

                                                  <!--<label *ngIf="l.OvarPos == 'Left' || 'LEFT' && l.OvarPos != 'Right' || 'RIGHT' ">{{l.Size}}</label>-->

                                                  <label class="margin-bottom-0px">{{l.Size}}</label>



                                                </td>

                                                <td class="td-padding ">
                                                  <div class="test-icons float-right">
                                                    <a (click)="del_(l.FollicularGrowthDetailCode)" class="nav-link-hand" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                                    <a (click)="edit(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                                      <span class="badge"><i class="fas fa-pencil-alt nav-link-hand"></i></span>
                                                    </a>
                                                  </div>
                                                </td>






                                              </tr>
                                            </ng-container>

                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="card">
                              <div class="card-header wh-header padding-right-0px padding-bottom-0px padding-top-0px padding-left-10px left-ovaries-background">
                                <label class="font-weight-normal font-size-14 margin-bottom-0px">Right Ovary</label>
                              </div>
                              <div class="card-body padding-top-0px padding-bottom-0px">
                                <div class="row">
                                  <div class="col-md-12 padding-left-0px padding-right-0px">
                                    <div class="table-component">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero">

                                          <!--<thead class="">
                                            <tr>
                                              <th class="min-width-0px">Left</th>

                                              <th class="min-width-0px">Right</th>
                                              <th>Count</th>
                                              <th>Size</th>

                                            </tr>
                                          </thead>-->
                                          <tbody class="table-body">
                                            <ng-container *ngFor="let l of CurrentFollicularScanOvaryDetailController">
                                              <tr *ngIf="l.OvarPos == 'Right'|| l.OvarPos == 'RIGHT'">
                                                <td class="td-padding ">

                                                  <label class="margin-bottom-0px">{{l.Count}}</label>


                                                </td>
                                                <td class="td-padding ">

                                                  <label class="margin-bottom-0px">{{l.Size}}</label>


                                                </td>

                                                <td class="td-padding ">
                                                  <div class="test-icons float-right">
                                                    <a (click)="del_(l.FollicularGrowthDetailCode)" class="nav-link-hand" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                                    <a (click)="edit(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                                      <span class="badge"><i class="fas fa-pencil-alt nav-link-hand"></i></span>
                                                    </a>
                                                  </div>
                                                </td>






                                              </tr>
                                            </ng-container>
                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row my-profile-form" *ngIf="FollicularData2.ActivityStatus =='Completed'">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                <label for="diaplayName" class="margin-bottom-0px">AFC Count</label>
                              </div>:

                              <div class="col-md-3 margin-tg-auto">
                                <label class="margin-bottom-0px " *ngIf="FollicularScanOvaryInfo">{{FollicularScanOvaryInfo.AFCCount}}</label>


                              </div>
                            </div>


                          </div>
                        </div>



                        <div class="row margin-left-0px margin-top-15px">
                          <div class="col-md-12 padding-left-0px">
                            <div class="accordion margin-bottom-20px" id="accordionExample5">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                          Procedures/Tests
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="button"
                                              class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddTests()"
                                              name="upload" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                    <!--<div class="col-md-6">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                    </div>-->
                                  </div>


                                </div>

                                <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="font-weight-normal font-size-14">Add/Edit</label>
                                          </div>
                                          <div class="col-md-3 text-align-right">
                                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                          </div>
                                        </div>

                                      </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-lg-11 col-md-11 col-xs-11 padding-right-0px">
                                            <div class="table-component table-tests">
                                              <div class="table-responsive">


                                                <table class="table table-striped margin-left-zero width-50-new">

                                                  <tbody class="table-body">

                                                    <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                                                      <!--<td class="padding-top-4px padding-bottom-4px ">{{l.Date | date:'MMM-dd-yyyy'}}</td>
                                                      <td class="padding-top-4px padding-bottom-4px ">{{l.TestName}}</td>
                                                      <td class=" padding-top-4px padding-bottom-4px ">{{l.Comments}}</td>-->
                                                      <td class="padding-bottom-4px padding-right-0px padding-t-6px vertical-align-top">{{RowIndex+1}}</td>
                                                      <td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                                        <div class="height-16px">
                                                          <label class="font-size-14 margin-bottom-0px">{{l.TestName}}</label>
                                                        </div>
                                                        <div class="row-height-17px">
                                                          <label class="font-size-12px margin-bottom-0px">Result : {{l.Result}}{{l.ResultUnits}}</label>
                                                        </div>
                                                        <div class="row-height-17px">
                                                          <label class="font-size-12px margin-bottom-0px">{{l.Comments}}</label>
                                                        </div>
                                                      </td>
                                                      <td class="padding-top-4px padding-bottom-4px">

                                                        <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                                                          <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                                        </a>-->
                                                        <div class="test-icons float-right">
                                                          <a (click)="delTEST(l)" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected delete-test-icon nav-link-hand"></i></a>
                                                          <a (click)="EditTest(l)" class="nav-link-hand education-navlink  color-Assign editicon edit-test-icon" title="Edit">
                                                            <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                                          </a>
                                                        </div>
                                                      </td>




                                                    </tr>

                                                  </tbody>
                                                </table>

                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="row margin-left-0px margin-top-15px">
                          <div class="col-md-12 padding-left-0px">
                            <div class="accordion margin-bottom-20px" id="accordionExample6">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSix">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                          Medicines
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="button"
                                              class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddMedicine()"
                                              name="upload" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                    <!--<div class="col-md-6">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                    </div>-->
                                  </div>


                                </div>

                                <div id="collapseSix" class="collapse show" aria-labelledby="headingSix" data-parent="#accordionExample6">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="font-weight-normal font-size-14">Add/Edit</label>
                                          </div>
                                          <div class="col-md-3 text-align-right">
                                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                          </div>
                                        </div>

                                      </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                        <div class="col-lg-11 col-md-11 col-xs-11 col-11 padding-right-0px ">


                                          <div class="table-component">
                                            <div class="table-responsive">


                                              <table class="table table-striped margin-left-zero width-50-new">
                                                <!--<thead>
                                                                                    <tr>
                                                                                      <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 th-width-40px padding-top-4px padding-bottom-4px"></th>
                                                                                      <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 padding-top-4px padding-bottom-4px">

                                                                                      </th>

                                                                                      <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                                </th>
                                                <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                                </th>
                                                <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                                </th>


                                                                                      <th class="font-weight-normal  background-primary padding-top-4px padding-bottom-4px">

                                                                                      </th>











                                                                                    </tr>
                                                                                  </thead>-->
                                                <tbody class="table-body">

                                                  <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                                                    <td class="padding-top-4px padding-bottom-4px padding-top-6px vertical-align-top">{{RowIndex+1}}</td>
                                                    <!--<td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                                      <div class="height-16px" >
                                                        <label class="font-size-14 margin-bottom-0px">{{l.MedicineName}}</label>
                                                      </div>
                                                      <div class="height-16px" >
                                                        <label class="font-size-12px margin-bottom-0px">{{l.Dose}}</label>
                                                      </div>
                                                      <div class="height-16px" >
                                                        <label class="font-size-12px margin-bottom-0px">{{l.DosageForm}}</label>
                                                      </div>
                                                      <div class="height-16px" >
                                                        <label class="font-size-12px margin-bottom-0px">{{l.MedicineInstructions}}</label>
                                                      </div>
                                                      <div class="height-16px" >
                                                        <label class="font-size-12px margin-bottom-0px">{{l.Remarks}}</label>
                                                      </div>

                                                    </td>-->
                                                    <td class="padding-top-4px padding-bottom-4px padding-left-4"><label class="font-size-12px margin-bottom-0px">{{l.MedicineName}}</label></td>
                                                    <td class=" padding-top-4px padding-bottom-4px ">{{l.Dosage}}{{l.DurationType}}</td>
                                                    <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.DosageForm}}</td>
                                                    <td class=" padding-top-4px padding-bottom-4px ">{{l.MedicineInstructions}}</td>

                                                    <td class="padding-top-4px padding-bottom-4px ">
                                                      <div class="test-icons float-right">
                                                        <a (click)="delMedicine(l)" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                                        <a (click)="EditMedicine(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                                          <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                                        </a>
                                                      </div>
                                                    </td>
                                                    <!--<td class="padding-top-4px padding-bottom-4px">


                                                    </td>-->




                                                  </tr>

                                                </tbody>
                                              </table>

                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div *ngIf="FollicularScanEndInfo && FollicularData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit_NextScanDate()" #f="ngForm">
                            <div class="accordion" id="accordionExampledate" *ngIf="FollicularData2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingdate">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsedate" aria-expanded="true" aria-controls="collapsedate">
                                          Next Scan Date
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button (click)="SaveEndometriumdetails()" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                  </div>


                                </div>

                                <div id="collapsedate" class="collapse show" aria-labelledby="headingdate" data-parent="#accordionExampledate">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Next Scan Date </label>
                                          </div>


                                          <div class="col-md-3">

                                            <div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp5" [(ngModel)]="NextScanDate" ngbDatepicker #d5="ngbDatepicker" #DateOfBirth="ngModel">
                                              <!--<small class="form-text text-danger"
                                              *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>-->
                                              <a (click)="d5.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>

                                          </div>

                                        </div>


                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div *ngIf="FollicularScanEndInfo && FollicularData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit_NextScanDate()" #f="ngForm">
                            <div class="accordion" id="accordionExampledate" *ngIf="FollicularData2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingdate">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsedate" aria-expanded="true" aria-controls="collapsedate">
                                          Next Scan Date
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button (click)="SaveEndometriumdetails()" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                  </div>


                                </div>

                                <div id="collapsedate" class="collapse show" aria-labelledby="headingdate" data-parent="#accordionExampledate">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Next Scan Date </label>
                                          </div>:


                                          <div class="col-md-5 margin-tg-auto">

                                            <!--<div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d1.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>-->
                                            <label class="margin-bottom-0px ">{{FollicularScanEndInfo.NextDocDate | date:'MMM-dd-yyyy'}}</label>
                                          </div>

                                        </div>


                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 padding-left-0px background-white" *ngIf="ScanDetails">
          <div class="row">
            <div class="position-fixed-Activities">

              <div class="col-md-12">
                <div class="card">
                  <div class="card-header wh-header  padding-left-0px padding-right-0px border-bottom-0px padding-top-0px ">
                    <ul class="nav nav-tabs nav-tab-ivf margin-top-3px" id="tabContent">
                      <li class="active nav-link-hand margin-right-5px"><a class="nav-item-ivf active" href="#details" data-toggle="tab">Activities</a></li>
                      <li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#access-security" data-toggle="tab">Forms</a></li>
                      <!--<li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#Forms" data-toggle="tab">Consent Forms</a></li>-->
                    </ul>
                  </div>
                  <div class="card-body padding-all-0px">
                    <div class="tab-content">
                      <div class="tab-pane active" id="details">

                        <div *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                          <cycleactivities [ActorCode]="SelectedpatientDetails.ActorID" [CycleCode]="SelectedpatientDetails.TreatmentCycle" [LMPDate]="LMPDate" ActivityName="FollicularScanEgg" [CanLoadReport]='CanLoadReport'></cycleactivities>
                        </div>
                        <div *ngIf="SelectedpatientDetails.EggSourceType=='Self'">
                          <cycleactivities [ActorCode]="SelectedpatientDetails.ActorID" [CycleCode]="SelectedpatientDetails.TreatmentCycle" [LMPDate]="LMPDate" ActivityName="FollicularScanSelf" [CanLoadReport]='CanLoadReport'></cycleactivities>
                        </div>

                      </div>
                      <div class="tab-pane" id="access-security">
                        <div class="card">
                          <div class="card-body padding-bottom-0px padding-top-0px">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="row">
                                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                    <div class="row">


                                      <div class="col-md-12">
                                        <CustomDataByRequestType RequestedType="FDActorReports" ActorCode="{{ActorCodeLoad()}}"
                                                                 id="CurrentFdActorReportsDocController.TemplateName" SelectedValue=""
                                                                 [(ngModel)]="SelectedReport"
                                                                 (keyChange)="onAssignedToActorCode($event)"
                                                                 (ngModelChange)="dataAcotrCode($event)"
                                                                 name="CurrentFdActorReportsDocController.TemplateName">
                                        </CustomDataByRequestType>
                                        <!--<CodeTypeValue CodeType="RELTP"></CodeTypeValue>-->


                                      </div>
                                      <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                                        <div *ngIf="fo && fo.AutoSections" class="margin-top-10">


                                          <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let section of  fo.AutoSections;let RowIndex = index">
                                            <div [id]="'accordion'+RowIndex">
                                              <div [ngSwitch]="section.SectionType">
                                                <div class="card-header wh-header font-size-16px  padding-top-0px padding-bottom-0px border-left-clinical padding-l-8px padding-right-0px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                                                  <h5 class="mb-0">
                                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                                            aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                                                      {{section.Data.Title}}

                                                    </button>
                                                  </h5>

                                                </div>
                                                <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                                                     [attr.data-parent]="'#accordion'+RowIndex">
                                                  <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                                                    <div class="row" *ngSwitchCase="'AttrVal'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px" *ngFor="let field of  section.Fields">


                                                        <div [ngSwitch]="field.Data.ValueType">
                                                          <div class="row" *ngSwitchCase="'Bool'">
                                                            <auto-gen-bool class="col-md-12" [Data]="field" [field]="field.Data"
                                                                           mode="view2">
                                                            </auto-gen-bool>
                                                          </div>
                                                          <div class="row" *ngSwitchCase="'List'">
                                                            <auto-gen-list class="col-md-12 padding-l-0px padding-right-0px" [Data]="field" [field]="field.Data"
                                                                           mode="view2">
                                                            </auto-gen-list>
                                                          </div>
                                                          <div class="row margin-top-5px" *ngSwitchCase="'Text'">
                                                            <auto-gen-text class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-text>
                                                          </div>
                                                          <div class="row margin-top-5px" *ngSwitchCase="'CVS'">
                                                            <auto-gen-cvs class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-cvs>
                                                          </div>
                                                          <div class="row" *ngSwitchCase="'Date'">
                                                            <auto-gen-date class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-date>
                                                          </div>
                                                          <div class="row padding-bottom-10px" *ngSwitchCase="'Grid'">
                                                            <!--<label>Grid: {{field.Title}}</label>-->
                                                            <auto-gen-grid class="col-md-12" [field]="field" mode="view2"></auto-gen-grid>
                                                          </div>

                                                          <div class="row" *ngSwitchDefault>




                                                          </div>





                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row" *ngSwitchCase="'Text'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px">
                                                        <!--*ngFor="let field of  section.Fields"-->

                                                        <div class="row">
                                                          <div class="col-md-12 " *ngFor="let field of section.Data.Fields">
                                                            <div class="row" *ngIf="field.ValueType=='Text'">

                                                              <div class="col-md-11 padding-left-0px padding-right-0px">

                                                                <textarea class="form-control3 size-2 width-inherit margin-top-5px margin-left-5px" placeholder="Remarks"
                                                                          [ngModelOptions]="{standalone: true}"
                                                                          [(ngModel)]="field.Value" maxlength="600"></textarea>

                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row" *ngSwitchCase="'Image'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px">
                                                        <!--*ngFor="let field of  section.Fields-->

                                                        <div class="row">
                                                          <div class="col-md-12">
                                                            <div class="table-component">
                                                              <div class="table-responsive">


                                                                <table class="table table-striped margin-left-zero">

                                                                  <!--<thead class="">
                                                                    <tr>
                                                                      <th class="min-width-0px width-57px padding-top-4px padding-bottom-4px"></th>

                                                                      <th class="width-53px padding-top-4px padding-bottom-4px">#</th>
                                                                      <th class="width-178px padding-top-4px padding-bottom-4px">Title</th>
                                                                      <th class="padding-top-4px padding-bottom-4px">Image</th>

                                                                      <th class="padding-top-4px padding-bottom-4px">Comments</th>
                                                                      <th class="padding-top-4px padding-bottom-4px"></th>
                                                                    </tr>
                                                                  </thead>-->
                                                                  <tbody class="table-body">

                                                                    <tr *ngFor="let field of section.Data.Fields; let RowIndex = index ">
                                                                      <!--<td class="padding-top-0px padding-bottom-0px ">

                                                                        <input type="checkbox" [(ngModel)]="field.IsSelected" />
                                                                        <i class="input-helper"></i>

                                                                      </td>-->
                                                                      <td class="padding-top-0px padding-bottom-0px ">{{RowIndex+1}}</td>

                                                                      <td class="padding-top-0px padding-bottom-0px ">
                                                                        <!--<input class="form-control " [(ngModel)]="field.Title" type="text" [ngModelOptions]="{standalone: true}" />-->
                                                                        <div><label class="margin-bottom-0px">{{field.Title}}</label></div>
                                                                        <div><label class="margin-bottom-0px"> {{field.Remarks}}</label></div>
                                                                      </td>
                                                                      <td class="padding-top-0px padding-bottom-0px padding-left-5px">

                                                                        <!--<div *ngIf="!field.HasImage">
                                                                          <button class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save">
                                                                            <i class="fas fa-ellipsis-h"></i>
                                                                          </button>
                                                                        </div>-->
                                                                        <div *ngIf="field.HasImage">
                                                                          <img class="img-circle-56 font-size-12px" [src]="field.ImageFile" onError="this.src='dummy.jpg';">
                                                                          <!--<button type="button" class="btn  btn-sm button-new-health margin-top-left" tooltip="Add" (click)="openDocContent(field)" *ngIf="field?.IsSelected"><i class="fas fa-plus nav-link-hand"></i></button>-->

                                                                        </div>
                                                                      </td>
                                                                      <!--<td class="padding-top-0px padding-bottom-0px">

                                                                        {{field.Remarks}}

                                                                      </td>-->
                                                                      <!--<td class="text-align-right padding-top-0px padding-bottom-0px">

                                                                        <a class="nav-link-hand font-size-20px margin-left-10px" title="Remove" *ngIf="field?.IsSelected"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>

                                                                      </td>-->



                                                                    </tr>

                                                                  </tbody>

                                                                </table>

                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <!--<label>{{f.Title}}</label>
                                                    <label class="margin-left-auto"></label>-->

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!--<div *ngFor="let l of CurrentFdActorReportsDocController">
                                              <label>{{l.TemplateName}}</label>
                                            </div>-->


                                          </div>

                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="Forms">
                        <div class="card">
                          <div class="card-body padding-bottom-0px padding-top-0px">

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>





      </div>
    </div>

  </div>

  <div class="job-posts placements agreements margin-top-service-30px top-link2 overscrollbehavior">


    <div class="row" *ngIf="displayPatientdata">
      <div class="col-md-3 col-12 padding-right-0px">

        <div class="position-fixed-sm-scans border-right2 padding-right-5px">
          <div class="card">

            <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
              <div class="row margin-top10px margin-left-20px  nav-link-hand">
                <div class="col-md-10 col-10 padding-left-0px">
                  <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                    Follicular Scans
                  </label>
                </div>
                <div class="col-md-1 col-1">
                  <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard2()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
                </div>




              </div>




            </div>
            <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
              <div class="row border-top margin-left-0px margin-right-0px margin-bottom-5px">
                <div class="col-md-1 col-1 padding-right-0px" (click)="DecrementDate()">
                  <a title="Previous" class="nav-link-hand">
                    <i class="fas fa-caret-left margin-top-5px font-size-28px color-secondary-hover"></i>
                  </a>
                </div>
                <div class="col-md-5 col-5 col-sm-4 padding-right-12px my-profile-form  padding-left-5px">
                  <div class="date-form margin-top-5px form-group margin-bottom-0px">
                    <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                           name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                    <a (click)="d.toggle()" class="nav-link-hand">
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>



                </div>

                <div class="col-md-1 col-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                  <a title="Next" class="nav-link-hand">
                    <i class="fas fa-caret-right margin-top-5px font-size-28px color-secondary-hover"></i>
                  </a>
                </div>
              </div>
              <div class="row margin-right-0px margin-left-0px" hidden>
                <div class="col-md-11 col-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                  <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
                </div>
                <div class="col-md-2" hidden>
                  <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                </div>
                <div class="col-md-1 padding-left-8px" hidden>
                  <a class="nav-link-hand education-navlink" tooltip="Edit">
                    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                  </a>

                </div>
                <div class="col-md-1 padding-left-8px" hidden>
                  <a class="nav-link-hand education-navlink" tooltip="Delete">
                    <span class="badge font-size-14">
                      <i class="far fa-trash-alt"></i>
                    </span>
                  </a>
                </div>

              </div>
              <div>
                <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                  <div *ngIf="isRequesting">

                    <div class="loader-text">
                      <div class="loader-text2">

                        <div class="lds-facebook">
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        <div class="margin-top-20px margin-left-5px">
                          <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                        </div>
                        <!--Loading Please Wait...-->
                      </div>
                    </div>


                  </div>
                  <div *ngIf="!isRequesting">
                    <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient2(l)" *ngFor="let l of pdata">
                      <div class="col-md-2 col-2 padding-left-0px margin-top-5px" (click)="Selectedpatient2(l)">


                        <!--<img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">-->

                        <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.FollicularGrowthOwnerPatientImageFile" onError="this.src='dummy.jpg';">

                      </div>
                      <div class="col-md-7 col-7 margin-top-5px padding-right-0px padding-left-0px">
                        <div class="row row-height-17px">
                          <div class="col-md-12 col-12">
                            <label class="margin-bottom-0px">{{l.OwnerName}}</label>
                          </div>

                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12 col-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.FollicularGrowthOwnerAgeYears}},{{l.FollicularGrowthOwnerFormattedCode}}</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4 col-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.FollicularGrowthOwnerTelephone1}}</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3  col-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">

                          <a data-toggle="tooltip" data-placement="bottom" title="Completed" *ngIf="l.ActivityStatus=='Completed'">

                            <i class="fas fa-check-circle color-icon-completed font-size-16px">
                            </i>
                          </a>
                          <a data-toggle="tooltip" data-placement="bottom" title="Initiated" *ngIf="l.ActivityStatus=='Initiated'">

                            <i class="fas fa-check-circle color-gray font-size-16px">
                            </i>
                          </a>
                          <!--<i class="fas fa-check-circle color-icon-completed "></i>-->

                        </div>
                        <div class="text-align-center"><label class="font-size-12px">{{l.LastUpdatedTime | date: 'hh:mm a'}}</label></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
    <div class="row margin-top-sm-13" *ngIf="displayscansdata">
      <div class="col-12">
        <div class="card">
          <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-1px">
            <div class="row margin-top10px margin-left-20px  nav-link-hand">
              <div class="col-md-10 col-10 padding-left-0px">
                <div class="row">
                  <div class="col-md-7 col-6 padding-right-0px">
                    <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                      Follicular Scans
                    </label>
                  </div>
                  <div class="col-md-6 col-5 margin-top-3px padding-left-0px padding-right-0px text-align-right" *ngIf="FollicularData2">
                    <div *ngIf="!SelectedpatientDetails.IsReadyForPickup || FollicularData2.ActivityStatus !=='Completed'">
                      <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal" (click)="pickup()" title="Is Ready For PickUp">Is Ready For PickUp</a>
                    </div>

                  </div>
                  <div class="col-1 margin-top-3px padding-left-0px padding-right-0px">
                    <div *ngIf="FollicularData2">
                      <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printfollicular2()" *ngIf="FollicularData2.ActivityStatus =='Completed'">
                        <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                      </a>
                    </div>
                  </div>
                </div>


              </div>
              <div class="col-md-1 col-1">
                <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackToPatientdata()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
              </div>




            </div>




          </div>
          <div class="card-body padding-all-0px">
            <div class="row margin-top-10" *ngIf="SelectedpatientDetails">
              <div class="col-md-1 col-2 ">
                <img class=" margin-left-6px image-width-scans width-small-52px" [src]="SelectedpatientDetails.FollicularGrowthOwnerPatientImageFile" onError="this.src='dummy.jpg';">
                <!--<img class=" margin-left-6px image-width-scans width-small-52px" src="dummy.jpg">-->
              </div>
              <div class="col-md-4 col-5 ">
                <div class="row row-height-17px margin-left-0px">

                  <label class="margin-bottom-0px font-weight-normal color-secondary font-size-14">{{SelectedpatientDetails.FollicularGrowthOwnerName}} </label>
                </div>
                <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR'">
                  <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                    <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                  </div>
                </div>
                <div class="row row-height-17px">
                  <div class="col-md-12">
                    <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.FollicularGrowthOwnerAgeYears}},{{SelectedpatientDetails.FollicularGrowthOwnerFormattedCode}}</label>
                  </div>
                </div>
                <div class="row row-height-17px">
                  <div class="col-md-4">

                    <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.FollicularGrowthOwnerTelephone1}}</label>
                  </div>
                </div>
              </div>
              <div class="offset-md-2  col-5 padding-left-0px col-md-4 text-align-right padding-right-0px">
                <div class="row font-size-12px">
                  <div class="col-md-6 col-6 padding-right-9px text-align-right-small">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
                  </div>:
                  <div class="col-md-5 col-5 padding-right-0px padding-left-5px text-align-right" *ngIf="FollicularData2">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
                  </div>
                </div>
                <div class="row font-size-12px">
                  <div class="col-md-6 col-6 padding-right-9px text-align-right-small">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
                  </div>:
                  <div class="col-md-5 col-5 padding-right-0px padding-left-5px text-align-right" *ngIf="FollicularData2">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularData2.ActivityStatus}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row margin-top-10">
              <div class="col-12">
                <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                  <div *ngIf="FollicularScanEndInfo">
                    <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">



                      <div class="accordion" id="accordionExample">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                            <div class="row">
                              <div class="col-md-4 col-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Endrometrium Thickness
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-8 col-8">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup && isvisibleendo">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                              </div>
                            </div>


                          </div>

                          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-15px padding-right-5px">

                              <div class="row my-profile-form margin-top-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px  margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Scan Date </label>
                                    </div>




                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">



                                    <div class="col-md-3 col-11">

                                      <div class="date-form">
                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp1" [(ngModel)]="ScanDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                        <!--<small class="form-text text-danger"
                        *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>-->
                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 col-6 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Endometrium Thickness </label>
                                    </div>


                                    <div class="col-md-3 col-3">


                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                      <small class="form-text text-danger"
                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">

                                    <div class="col-md-3 col-8">

                                      <input type="number" class="form-control" placeholder="Endometrium Thickness"
                                             id="FollicularScanEndInfo.EndometriumThickness"
                                             [(ngModel)]="FollicularScanEndInfo.EndometriumThickness"
                                             name="FollicularScanEndInfo.EndometriumThickness" #Endometrium="ngModel"
                                             maxlength="100" required>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(special characters are not allowed)</small>
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                      <small class="form-text text-danger"
                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>
                                    <div class="col-3">
                                      <CodeTypeValue CodeType="ENMU"
                                                     id="FollicularScanEndInfo.EndometriumThicknessUnits"
                                                     [(ngModel)]="FollicularScanEndInfo.EndometriumThicknessUnits" SelectedValue="FollicularScanEndInfo.EndometriumThicknessUnits"
                                                     name="FollicularScanEndInfo.EndometriumThicknessUnits">
                                      </CodeTypeValue>


                                    </div>



                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Comments</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                                                name="FollicularScanEndInfo.Comments"
                                                [(ngModel)]="FollicularScanEndInfo.Comments" required minlength="1" maxlength="100"
                                                #addconcerns_text="ngModel"></textarea>
                                      <small class="form-text text-danger"
                                             *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Sign1</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                               id="FollicularScanEndInfo.Sign1Actor" SelectedValue="FollicularScanEndInfo.Sign1Actor"
                                                               [(ngModel)]="FollicularScanEndInfo.Sign1Actor" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                               name="FollicularScanEndInfo.Sign1Actor" required>
                                      </CustomDataByRequestType>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Sign2</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                               id="FollicularScanEndInfo.Sign2Actor" SelectedValue=""
                                                               [(ngModel)]="FollicularScanEndInfo.Sign2Actor" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                               name="FollicularScanEndInfo.Sign2Actor" required>
                                      </CustomDataByRequestType>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture' && SelectedpatientDetails.TCModelName=='Fet' && FollicularData2 && FollicularScanEndInfo">
                    <form class="form " novalidate="" (ngSubmit)="onSubmitAdditional()" #f="ngForm">



                      <div class="accordion" id="accordionExample7">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="heading7">
                            <div class="row">
                              <div class="col-md-4 col-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapse7" aria-expanded="true" aria-controls="collapse7">
                                    Additional Details
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-8 col-8">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                              </div>
                            </div>


                          </div>

                          <div id="collapse7" class="collapse show" aria-labelledby="heading7" data-parent="#accordionExample7">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-15px padding-right-5px">

                              <div class="row my-profile-form margin-top-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px  margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Blood Flow Zone </label>
                                    </div>




                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">



                                    <div class="col-md-3 col-11">

                                      <CodeTypeValue CodeType="BFLWZ"
                                                     id="FollicularScanEndInfo.BloodFlowZone"
                                                     [(ngModel)]="FollicularScanEndInfo.BloodFlowZone" SelectedValue="FollicularScanEndInfo.BloodFlowZone"
                                                     name="FollicularScanEndInfo.BloodFlowZone">
                                      </CodeTypeValue>

                                    </div>

                                  </div>


                                </div>
                              </div>

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-11 padding-right-0px text-align-right margin-top-auto">
                                      <label for="diaplayName" class="font-size-16px margin-bottom-0px font-weight-bold">Adjuvants:</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 col-6 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Evion </label>
                                    </div>


                                    <div class="col-md-3 col-3">


                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                      <small class="form-text text-danger"
                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">

                                    <div class="col-md-3 col-8">

                                      <CodeTypeValue CodeType="YESNO"
                                                     id="FollicularScanEndInfo.Evion"
                                                     [(ngModel)]="FollicularScanEndInfo.Evion" SelectedValue="FollicularScanEndInfo.Evion"
                                                     name="FollicularScanEndInfo.Evion">
                                      </CodeTypeValue>
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                      <small class="form-text text-danger"
                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>




                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Intauterine GCSF</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="YESNO"
                                                     id="FollicularScanEndInfo.GCSF"
                                                     [(ngModel)]="FollicularScanEndInfo.GCSF" SelectedValue="FollicularScanEndInfo.GCSF"
                                                     name="FollicularScanEndInfo.GCSF">
                                      </CodeTypeValue>

                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>BAPC</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="YESNO"
                                                     id="FollicularScanEndInfo.BAPC"
                                                     [(ngModel)]="FollicularScanEndInfo.BAPC" SelectedValue="FollicularScanEndInfo.BAPC"
                                                     name="FollicularScanEndInfo.BAPC">
                                      </CodeTypeValue>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="table-component margin-bottom-0px padding-all-3px">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero">

                                    <thead class="">
                                      <tr>
                                        <th class=" td-width-107px padding-left-4"></th>
                                        <th class="padding-left-5px width-70px">UterineArtery Left</th>
                                        <th class="padding-left-5px width-70px">UterineArtery Right</th>


                                      </tr>
                                    </thead>
                                    <tbody class="table-body">
                                      <tr>
                                        <!--<td class="td-padding text-align-center">

                                                        <input type="checkbox" [(ngModel)]="IsLeft" (change)="LeftOrRight('Left',isChecked? 'true' : 'false')" />


                                                      </td>
                                                      <td class="td-padding text-align-center">

                                                        <input type="checkbox" [(ngModel)]="IsRight"
                                                               (change)="LeftOrRight('Right' ,isChecked? 'true' : 'false')" />


                        </td>-->
                                        <td class="padding-all-0px">
                                          RI
                                        </td>

                                        <td class="td-padding ">

                                          <input type="text" class="form-control"
                                                 min="1" max="10" id="FollicularScanEndInfo.RILeft"
                                                 [(ngModel)]="FollicularScanEndInfo.RILeft"
                                                 name="FollicularScanEndInfo.RILeft" #Count="ngModel"
                                                 maxlength="50">
                                          <small class="form-text text-danger"
                                                 *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                          <small class="form-text text-danger"
                                                 *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                        </td>
                                        <td class="td-padding ">
                                          <input type="text" class="form-control"
                                                 min="1" max="10" id="FollicularScanEndInfo.RIRight"
                                                 [(ngModel)]="FollicularScanEndInfo.RIRight"
                                                 name="FollicularScanEndInfo.RIRight" #Size="ngModel"
                                                 maxlength="50">
                                          <small class="form-text text-danger"
                                                 *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                          <small class="form-text text-danger"
                                                 *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                        </td>





                                      </tr>
                                      <tr>
                                        <!--<td class="td-padding text-align-center">

                                                        <input type="checkbox" [(ngModel)]="IsLeft" (change)="LeftOrRight('Left',isChecked? 'true' : 'false')" />


                                                      </td>
                                                      <td class="td-padding text-align-center">

                                                        <input type="checkbox" [(ngModel)]="IsRight"
                                                               (change)="LeftOrRight('Right' ,isChecked? 'true' : 'false')" />


                        </td>-->
                                        <td class="padding-all-0px">
                                          PI
                                        </td>

                                        <td class="td-padding ">

                                          <input type="text" class="form-control"
                                                 min="1" max="10" id="FollicularScanEndInfo.PILeft"
                                                 [(ngModel)]="FollicularScanEndInfo.PILeft"
                                                 name="FollicularScanEndInfo.PILeft" #Count="ngModel"
                                                 maxlength="50">
                                          <small class="form-text text-danger"
                                                 *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                          <small class="form-text text-danger"
                                                 *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                        </td>
                                        <td class="td-padding ">
                                          <input type="text" class="form-control"
                                                 min="1" max="10" id="FollicularScanEndInfo.PIRight"
                                                 [(ngModel)]="FollicularScanEndInfo.PIRight"
                                                 name="FollicularScanEndInfo.PIRight" #Size="ngModel"
                                                 maxlength="50">
                                          <small class="form-text text-danger"
                                                 *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                          <small class="form-text text-danger"
                                                 *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                        </td>





                                      </tr>


                                    </tbody>

                                  </table>
                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="accordion" id="accordionExample2">
                    <form class="form " novalidate="" (ngSubmit)="onSubmitOvary()" #f="ngForm">
                      <div class="card margin-bottom-5px">
                        <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                          <div class="row">
                            <div class="col-md-4 col-4">
                              <h5 class="mb-0 height-24px">
                                <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                  Follicles (Count/Size)
                                </button>
                              </h5>
                            </div>
                            <div class="col-md-8 col-8">
                              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                              <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                            </div>
                            <!--<div class="col-md-6">
              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
              <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
            </div>-->
                          </div>


                        </div>

                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                          <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                            <div class="card margin-bottom-0px background-lightpink">
                              <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                <div class="row">
                  <div class="col-md-3">
                    <label class="font-weight-normal font-size-14">Add/Edit</label>
                  </div>
                  <div class="col-md-3 text-align-right">
                    <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                    <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                  </div>
                </div>

              </div>-->
                              <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                <div class="table-component margin-bottom-0px padding-all-5px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                  <div class="table-responsive">


                                    <table class="table table-striped margin-left-zero">

                                      <thead class="">
                                        <tr>
                                          <th class=" td-width-107px padding-left-4">Ov.Position</th>
                                          <th class="padding-left-5px">Count</th>
                                          <th class="padding-left-5px">Size</th>
                                          <th>Comments</th>

                                        </tr>
                                      </thead>
                                      <tbody class="table-body">

                                        <tr>
                                          <td class="padding-all-0px">
                                            <CodeTypeValue CodeType="OVPS"
                                                           id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                                           [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                                           name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                                            </CodeTypeValue>
                                          </td>

                                          <td class="td-padding ">

                                            <input type="number" class="form-control"
                                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                                   maxlength="100">
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                          </td>
                                          <td class="td-padding ">
                                            <input type="number" class="form-control"
                                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                                   maxlength="100">
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                          </td>

                                          <td class="td-padding ">
                                            <input type="text" class="form-control"
                                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                                   maxlength="100">
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                          </td>



                                        </tr>

                                      </tbody>

                                    </table>

                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="row margin-left-0px margin-right-0px">
                    <div class="col-md-6 col-12 padding-left-6px padding-right-6px">
                      <div class="card">
                        <div class="card-header wh-header padding-right-0px padding-bottom-0px padding-top-0px padding-left-10px left-ovaries-background">
                          <label class="font-weight-normal font-size-14">Left Ovaries</label>
                        </div>
                        <div class="card-body padding-top-0px padding-bottom-0px">
                          <div class="row">
                            <div class="col-md-12 padding-left-0px padding-right-0px">
                              <div class="table-component">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero">

                                    <!--<thead class="">
                      <tr>
                        <th class="min-width-0px">Left</th>

                        <th class="min-width-0px">Right</th>
                        <th>Count</th>
                        <th>Size</th>

                      </tr>
                    </thead>-->
                                    <tbody class="table-body">
                                      <ng-container *ngFor="let l of CurrentFollicularScanOvaryDetailController">
                                        <tr *ngIf="l.OvarPos == 'Left'|| l.OvarPos == 'LEFT'">
                                          <td class="td-padding ">

                                            <label class="margin-bottom-0px">{{l.Count}}</label>




                                          </td>
                                          <td class="td-padding ">

                                            <label class="margin-bottom-0px">{{l.Size}}</label>


                                          </td>


                                          <td class="td-padding ">
                                            <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                              <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                            </a>-->
                                            <div class="test-icons float-right">
                                              <a (click)="del_(l.FollicularGrowthDetailCode)" class="nav-link-hand" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                              <a (click)="edit(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                                <span class="badge"><i class="fas fa-pencil-alt nav-link-hand"></i></span>
                                              </a>
                                            </div>
                                          </td>





                                        </tr>
                                      </ng-container>


                                    </tbody>

                                  </table>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row margin-left-0px margin-right-0px">

                    <div class="col-md-6 col-12 padding-left-6px padding-right-6px">
                      <div class="card">
                        <div class="card-header wh-header padding-right-0px padding-bottom-0px padding-top-0px padding-left-10px left-ovaries-background">
                          <label class="font-weight-normal font-size-14">Right Ovaries</label>
                        </div>
                        <div class="card-body padding-top-0px padding-bottom-0px">
                          <div class="row">
                            <div class="col-md-12 padding-left-0px padding-right-0px">
                              <div class="table-component">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero">

                                    <!--<thead class="">
                      <tr>
                        <th class="min-width-0px">Left</th>

                        <th class="min-width-0px">Right</th>
                        <th>Count</th>
                        <th>Size</th>

                      </tr>
                    </thead>-->
                                    <tbody class="table-body">
                                      <ng-container *ngFor="let l of CurrentFollicularScanOvaryDetailController">
                                        <tr *ngIf="l.OvarPos == 'Right'|| l.OvarPos == 'RIGHT'">


                                          <td class="td-padding ">

                                            <label class="margin-bottom-0px">{{l.Count}}</label>


                                          </td>
                                          <td class="td-padding ">

                                            <label class="margin-bottom-0px">{{l.Size}}</label>




                                          </td>


                                          <td class="td-padding ">
                                            <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                              <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                            </a>-->
                                            <div class=" test-icons float-right">
                                              <a (click)="del_(l.FollicularGrowthDetailCode)" class="nav-link-hand" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                              <a (click)="edit(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                                <span class="badge"><i class="fas fa-pencil-alt nav-link-hand"></i></span>
                                              </a>
                                            </div>

                                          </td>





                                        </tr>
                                      </ng-container>
                                    </tbody>

                                  </table>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row my-profile-form">
                    <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                      <div class="row">
                        <div class="col-md-3 offset-1 col-3 padding-right-0px text-align-center margin-top-auto">
                          <label for="diaplayName" class="font-size-12px margin-bottom-0px">AFC Count</label>
                        </div>

                        <div class="col-md-3 col-5 padding-left-0px">
                          <!--<input type="number" class="form-control"
          min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount"
          [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount"
          name="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount" #AFCCount="ngModel"
          maxlength="100">-->
                          <input type="text" class="form-control"
                                 min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount"
                                 [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount"
                                 name="CurrentSaveFollicularScanOvaryDetailRequest.AFCCount" pattern="^[\0-9,._\-?]*$" #AFCCount="ngModel"
                                 maxlength="5">
                          <small class="form-text text-danger"
                                 *ngIf="(!AFCCount.valid && (AFCCount.dirty || AFCCount.touched) && AFCCount.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!AFCCount.valid && AFCCount.errors.pattern)">(only numbers are allowed)</small>

                          <!--<input type="text" class="form-control" placeholder="Cycle No"
                 id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                 [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                 name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                 maxlength="5" />
          <small class="form-text text-danger"
                 *ngIf="(!RecommendedPackage.valid && (RecommendedPackage.dirty || RecommendedPackage.touched) && RecommendedPackage.errors.required )">(Field cannot be left blank)</small>
          <small class="form-text text-danger"
                 *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>-->


                        </div>
                      </div>


                    </div>
                  </div>
                  <div class="accordion" id="accordionExampletest">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingtest">
                        <div class="row">
                          <div class="col-md-4 col-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsetest" aria-expanded="true" aria-controls="collapsetest">
                                Procedures/Tests
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 col-7 padding-right-0px">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddTests()"
                                    name="upload" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                          </div>
                        </div>


                      </div>

                      <div id="collapsetest" class="collapse show" aria-labelledby="headingtest" data-parent="#accordionExampletest">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row">
                            <div class="col-11 padding-right-0px">
                              <div class="table-component table-tests">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero width-50-new">

                                    <tbody class="table-body">

                                      <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                                        <!--<td class="padding-top-4px padding-bottom-4px ">{{l.Date | date:'MMM-dd-yyyy'}}</td>
                        <td class="padding-top-4px padding-bottom-4px ">{{l.TestName}}</td>
                        <td class=" padding-top-4px padding-bottom-4px ">{{l.Comments}}</td>-->
                                        <td class="padding-top-6px padding-bottom-4px padding-right-0px vertical-align-top">{{RowIndex+1}}</td>
                                        <td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                          <div class="height-16px">
                                            <label class="font-size-14 margin-bottom-0px">{{l.TestName}}</label>
                                          </div>
                                          <div class="row-height-17px">
                                            <label class="font-size-12px margin-bottom-0px">Result : {{l.Result}}{{l.ResultUnits}}</label>
                                          </div>
                                          <div class="row-height-17px">
                                            <label class="font-size-12px margin-bottom-0px">{{l.Comments}}</label>
                                          </div>
                                        </td>
                                        <td class="padding-top-4px padding-bottom-4px">
                                          <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                            <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                          </a>-->
                                          <div class="test-icons float-right">
                                            <a (click)="delTEST(l)" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected delete-test-icon nav-link-hand"></i></a>
                                            <!--<a (click)="EditTest(l)" class="nav-link-hand education-navlink  color-Assign editicon edit-test-icon" title="Edit">
                              <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                            </a>-->
                                          </div>
                                        </td>




                                      </tr>

                                    </tbody>
                                  </table>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion" id="accordionExamplemedicine">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingmedicine">
                        <div class="row">
                          <div class="col-md-4 col-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsemedicine" aria-expanded="true" aria-controls="collapsemedicine">
                                Medicines
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 col-7 padding-right-0px">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddMedicine()"
                                    name="upload" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                          </div>
                        </div>


                      </div>

                      <div id="collapsemedicine" class="collapse show" aria-labelledby="headingmedicine" data-parent="#accordionExamplemedicine">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row">
                            <div class="col-11 padding-right-0px">
                              <div class="table-component">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero width-50-new">
                                    <!--<thead>
                                                        <tr>
                                                          <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 th-width-40px padding-top-4px padding-bottom-4px"></th>
                                                          <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 padding-top-4px padding-bottom-4px">

                                                          </th>

                                                          <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                    </th>
                    <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                    </th>
                    <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                    </th>


                                                          <th class="font-weight-normal  background-primary padding-top-4px padding-bottom-4px">

                                                          </th>











                                                        </tr>
                                                      </thead>-->
                                    <tbody class="table-body">

                                      <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                                        <td class="padding-top-4px padding-bottom-4px padding-top-6px vertical-align-top">{{RowIndex+1}}</td>
                                        <!--<td class="padding-top-4px padding-bottom-4px padding-left-0px">
                          <div class="height-16px" >
                            <label class="font-size-14 margin-bottom-0px">{{l.MedicineName}}</label>
                          </div>
                          <div class="height-16px" >
                            <label class="font-size-12px margin-bottom-0px">{{l.Dose}}</label>
                          </div>
                          <div class="height-16px" >
                            <label class="font-size-12px margin-bottom-0px">{{l.DosageForm}}</label>
                          </div>
                          <div class="height-16px" >
                            <label class="font-size-12px margin-bottom-0px">{{l.Instructions}}</label>
                          </div>
                          <div class="height-16px" >
                            <label class="font-size-12px margin-bottom-0px">{{l.Remarks}}</label>
                          </div>

                        </td>-->
                                        <td class="padding-top-4px padding-bottom-4px padding-left-4"><label class="font-size-12px margin-bottom-0px">{{l.MedicineName}}</label></td>
                                        <td class=" padding-top-4px padding-bottom-4px ">{{l.Dose}}</td>
                                        <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.DosageForm}}</td>
                                        <td class=" padding-top-4px padding-bottom-4px ">{{l.MedicineInstructions}}</td>

                                        <td class="padding-top-4px padding-bottom-4px ">
                                          <div class="test-icons">
                                            <a class="float-right" (click)="delMedicine(l)" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                            <!--<a (click)="EditMedicine()" class="nav-link-hand education-navlink  color-Assign" title="Edit">
                              <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                            </a>-->
                                          </div>
                                        </td>
                                        <!--<td class="padding-top-4px padding-bottom-4px">


                        </td>-->




                                      </tr>

                                    </tbody>
                                  </table>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="FollicularScanEndInfo">
                    <form class="form " novalidate="" (ngSubmit)="onSubmit_NextScanDate()" #f="ngForm">
                      <div class="accordion" id="accordionExampledate">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingdate">
                            <div class="row">
                              <div class="col-md-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsedate" aria-expanded="true" aria-controls="collapsedate">
                                    Next Scan Date
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-8 ">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                <button (click)="SaveEndometriumdetails()" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                              </div>
                            </div>


                          </div>

                          <div id="collapsedate" class="collapse show" aria-labelledby="headingdate" data-parent="#accordionExampledate">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-center margin-top-auto margin-bottom-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Next Scan Date </label>
                                    </div>


                                    <div class="col-md-3 col-4 padding-left-0px">

                                      <div class="date-form">
                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp5" [(ngModel)]="NextScanDate" ngbDatepicker #d5="ngbDatepicker" #DateOfBirth="ngModel">
                                        <!--<small class="form-text text-danger"
                        *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>-->
                                        <a (click)="d5.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>

                                    </div>

                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
